module.exports = __webpack_public_path__ + "ea1f89f1063822b5d70458976122f765.svg";